import { render } from "./FooterInPage.vue?vue&type=template&id=42babb5e"
import script from "./FooterInPage.vue?vue&type=script&lang=js"
export * from "./FooterInPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__